import React from 'react';
import OpensInNewTab from '../components/OpensInNewTab';
import { trackBookingOutbound, trackPhoneClick } from '../utils/analytics';

const WaitlistForm: React.FC = () => {
  return (
    <div className="min-h-[80vh] bg-white md:bg-gradient-to-br md:from-soft-gray md:via-white md:to-orange-50 flex items-start md:items-center justify-center pb-12">
      <div className="w-full max-w-2xl">
        {/* Mobile Hero Image */}
        <div className="md:hidden relative w-full h-64 overflow-hidden mb-6">
          <img 
            src="/homeimagebouviercat.png" 
            alt="Happy dog and cat" 
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-transparent to-white/90"></div>
          <div className="absolute bottom-0 left-0 right-0 p-6 text-center">
            <h2 className="text-3xl font-bold text-hellotend-brand-brown font-nantes drop-shadow-sm">
              We're Open!
            </h2>
          </div>
        </div>

        {/* Content */}
        <div className="bg-white rounded-3xl shadow-none md:shadow-2xl overflow-hidden max-w-6xl mx-auto w-full">
          <div className="hidden md:block h-2 bg-gradient-to-r from-brand-teal to-orange-400"></div>
          
          <div className="p-8 md:p-12 lg:p-16 text-center">
             <div className="w-20 h-20 bg-white rounded-2xl flex items-center justify-center mb-6 shadow-md mx-auto">
                <img 
                  src="/chomp_logo_final.png" 
                  alt="CHOMP Pet Dental — booking page logo" 
                  className="w-12 h-12 object-contain"
                />
              </div>
              
              <h1 className="text-4xl lg:text-5xl font-bold text-hellotend-brand-brown mb-6 font-nantes leading-tight">
                Request your pet's dental appointment
              </h1>
              
              <div className="max-w-2xl mx-auto space-y-6 text-lg text-gray-700 leading-relaxed font-founders">
                <p>
                  Dog and cat dental care at 1800 E Commercial Blvd in Fort Lauderdale.
                </p>
                <p>
                  Request an appointment through our booking portal, or call our team. We'll contact you to discuss your pet's needs and confirm appointment details.
                </p>
                <p>
                  Book by calling Chomp at <a href="tel:+19544663775" className="font-bold text-brand-teal hover:underline" onClick={() => trackPhoneClick('book_page')}>(954) 466-3775</a> or use the appointment request button below.
                </p>
              </div>

              <div className="mt-10">
                <a 
                  href="https://petportal.vet/chomp-pet-dental/appointment/request"
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={() => trackBookingOutbound('book_page')}
                  className="inline-block bg-brand-teal text-white px-10 py-5 rounded-xl font-bold text-xl shadow-lg hover:bg-teal-700 hover:scale-[1.02] transition-all"
                >
                  REQUEST A BOOKING
                  <OpensInNewTab />
                </a>
              </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WaitlistForm;